var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWorkInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92px",
    height: "110px",
    viewBox: "0 0 92 110",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WORK JOB Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.3043787,90.1720891 C14.5635994,85.016631 0,67.1195754 0,45.8333333 C0,20.5202823 20.5949015,0 46,0 C71.4050985,0 92,20.5202823 92,45.8333333 C92,67.1195754 77.4364006,85.016631 57.6956213,90.1720891 L46,110 L34.3043787,90.1720891 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.8%",
    y: "-3.2%",
    width: "107.6%",
    height: "106.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "shadowSpreadInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.988786139   0 0 0 0 0.233931569   0 0 0 0 0.233931569  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.816203773   0 0 0 0 0.00751322834   0 0 0 0 0.106696017  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadInner3"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadInner3",
    result: "shadowOffsetInner3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner3",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.600685587   0 0 0 0 0   0 0 0 0 0  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner3",
    result: "shadowMatrixInner3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner3"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iphone6-WJ-3",
    transform: "translate(-382.000000, -150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WORK-JOB-3",
    transform: "translate(382.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D0011B",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "WORK",
    transform: "translate(2.787879, 2.777778)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    transform: "translate(43.980134, 43.494037) rotate(46.000000) translate(-43.980134, -43.494037) translate(12.591599, 13.016330)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(31.388535, 29.719839) scale(-1, 1) rotate(90.000000) translate(-31.388535, -29.719839) translate(20.738854, -1.312008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.635903,18.2225182 L10.6319853,11.1873564 C8.35110294,11.1873564 6.83776042,10.6256147 6.09195772,9.5021312 C6.09195772,3.18586857 6.03475031,0.0184914982 5.92033548,0 C3.25905331,0.311606733 0,5.06167279 0,9.9351821 C8.90833321e-17,14.8086914 3.32805607,17.3850069 4.92598805,19.0892233 C6.52392004,20.7934398 6.49257812,26.310903 6.21328125,35.615625 C6.21694623,36.8727762 6.0655867,43.3341179 5.76286765,54.9882181 C5.64296078,59.3539639 7.25925982,61.547239 10.6117648,61.5680434 C10.6198207,61.5681928 10.6278669,61.5681804 10.635903,61.5681555 C10.6439392,61.5681804 10.6519853,61.5681928 10.6600414,61.5681928 C14.0125462,61.547239 15.6288453,59.3539639 15.5089384,54.9882181 C15.2062194,43.3341179 15.0548598,36.8727762 15.0585248,35.615625 C14.7792279,26.310903 14.747886,20.7934398 16.345818,19.0892233 C17.94375,17.3850069 21.2718061,14.8086914 21.2718061,9.9351821 C21.2718061,5.06167279 18.0127528,0.311606733 15.3514706,0 C15.2370558,0.0184914982 15.1798483,3.18586857 15.1798483,9.5021312 C14.4340456,10.6256147 12.9207031,11.1873564 10.6398208,11.1873564 L10.635903,18.2225182 Z",
    id: "Combined-Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(26.658824, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.47058824,5.88529412 L7.50588235,5.88529412 L6.92605699,0 L3.42688419,0 L2.84705882,5.88529412 L3.88235294,5.88529412 L3.88235294,24.0529412 L6.47058824,24.0529412 L6.47058824,5.88529412 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.21040336,42.8005906 L0.170835466,42.8005906 L0.170835466,60.7123553 L9.74730605,60.7123553 L9.74730605,43.1400491 L9.75369419,43.1400491 L9.74730605,43.0746928 L9.74730605,42.8005906 L9.72051443,42.8005906 L9.05557838,35.9977019 L0.87533941,35.9977019 L0.21040336,42.8005906 Z",
    id: "Combined-Shape"
  }))))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkInProgress);
export default __webpack_public_path__ + "static/media/work-in-progress.a190226b0247323cb9467e61ff3f9ce0.svg";
export { ForwardRef as ReactComponent };